/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import StorageService from './storage-service';

// Access token lives in memory only — never written to localStorage.
// This prevents XSS scripts from stealing the token across page navigations.
// On page reload the interceptor triggers a silent refresh via the httpOnly
// refresh-token cookie set by the backend.
let _accessToken = null;

// Remove any previously persisted token left over from before this change.
try { localStorage.removeItem('accessToken'); localStorage.removeItem('refreshToken'); } catch (_) {}

class AuthStorageService extends StorageService {
  storeUser = (user) => {
    this.store('user', user);
  };

  getUser = () => this.get('user');

  removeUser = () => {
    this.remove('user');
  };

  // Access token — memory only
  storeAccessToken = (token) => { _accessToken = token; };
  getAccessToken = () => _accessToken;
  removeAccessToken = () => { _accessToken = null; };

  // Refresh token — managed by the httpOnly cookie set server-side; no localStorage.
  storeRefreshToken = () => {};
  getRefreshToken = () => null;
  removeRefreshToken = () => {};

  changeThemeMode = (mode) => {
    this.store('mode', mode);
  };

  getTaskId = () => this.get('taskId');

  removeTaskId = () => {
    this.remove('taskId');
  };

  changeTaskId = (taskId) => {
    this.store('taskId', taskId);
  };

  getThemeMode = () => this.get('mode');

  storeMfaPreAuthToken = (token) => {
    this.store('mfaPreAuthToken', token);
  };

  getMfaPreAuthToken = () => this.get('mfaPreAuthToken');

  removeMfaPreAuthToken = () => {
    this.remove('mfaPreAuthToken');
  };

  storeMfaEnrolled = (enrolled) => {
    this.store('mfaEnrolled', enrolled);
  };

  getMfaEnrolled = () => this.get('mfaEnrolled');

  removeMfaEnrolled = () => {
    this.remove('mfaEnrolled');
  };
}

export const AuthStorage = new AuthStorageService();
